import instanceJWT from "./apiJwt";
import type { UserProfile } from "../models/eplex/License";

/**
 * Возвращает настройки/профиль текущего пользователя (телефон, почта, ФИО, гео и т.п.).
 * Тот же эндпоинт используется в разделе лицензии.
 */
export async function getProfileSettings(): Promise<UserProfile> {
  const response = await instanceJWT.get("profile/settings");
  return (response.data?.data ?? {}) as UserProfile;
}
